module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27897",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4356",
      "atom": "static-1.4729",
      "conversations-async-data": "static-2.7317",
      "conversations-error-reporting": "static-1.8533",
      "conversations-internal-pub-sub": "static-1.15620",
      "conversations-internal-schema": "static-1.12281",
      "conversations-message-history": "static-1.11599",
      "conversations-test-sdk": "static-1.10152",
      "conversations-visitor-experience-components": "static-1.21260",
      "head-dlb": "static-1.4702",
      "hs-promise-utils": "static-1.5244",
      "hs-test-utils": "static-1.7639",
      "hubspot-dlb": "static-2.1767",
      "HubStyleTokens": "static-2.11072",
      "I18n": "static-7.1528",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2666",
      "jasmine-runner": "static-1.6108",
      "quartz": "static-1.6515",
      "react-dlb": "static-1.67",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.58",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4130",
      "StyleGuideUI": "static-3.481",
      "transmute": "static-2.77",
      "urlinator": "static-1.4181",
      "usage-tracker": "static-1.6989",
      "usage-tracker-core": "static-1.6839",
      "usage-tracker-public": "static-1.6800",
      "viral-links-lib": "static-1.6670",
      "visitor-ui-component-library": "static-1.5781",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4433",
      "conversations-prop-types": "static-1.7102",
      "conversations-visitor-message-history": "static-1.19997",
      "cssUtils": "static-1.683",
      "enviro": "static-4.371",
      "flux-actions": "static-1.294",
      "foundations-components": "static-1.7203",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5820",
      "hubspot-url-utils": "static-1.3819",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9286",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.334",
      "raven": "static-3.5564",
      "react": "static-7.151",
      "react-aria": "static-1.58",
      "react-dom": "static-7.85",
      "react-redux": "static-7.65",
      "react-rhumb": "static-1.16279",
      "react-utils": "static-2.5045",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7796",
      "signup-constants": "static-1.18081",
      "styled-components": "static-2.83",
      "usage-tracker-multi": "static-1.5403",
      "visitor-ui-component-library-icons": "static-1.5592",
      "hs-promise-rejection-tracking": "static-1.5234",
      "raven-hubspot": "static-1.5871",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3093",
      "moment": "static-3.26",
      "quartz-config": "static-1.293",
      "quartz-core": "static-1.5734",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4484",
      "foundations-theming": "static-1.4056",
      "UIComponents": "static-3.8019",
      "cv-backend-services": "static-1.1429",
      "immutable-less": "static-1.4305",
      "conversations-skeleton-state": "static-1.6907",
      "crm-events-viz-core": "static-1.31961",
      "customer-agent-discovery-components-lib": "static-1.2068",
      "customer-data-objects": "static-1.7264",
      "data-fetching-client": "static-1.9329",
      "icons": "static-2.601",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4258",
      "tanstack-virtual": "static-1.23",
      "ui-images": "static-2.1042",
      "HeadJS": "static-2.679",
      "framer-motion": "static-1.62",
      "hs-test-utils-bend-plugin": "static-1.2750",
      "msw": "static-1.39",
      "testing-library": "static-1.144",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jasmine": "static-4.3987",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7711",
      "HubStyle": "static-2.11380",
      "quartz-i18n": "static-1.190",
      "sassPrefix": "static-1.149",
      "bend-plugin-foundations-components": "static-1.3472",
      "floating-ui": "static-1.49",
      "foundations-theming-specialty": "static-1.1772",
      "hs-story-utils": "static-1.9085",
      "react-virtualized": "static-2.91",
      "tanstack-table": "static-1.48",
      "trellis-assets": "static-1.899",
      "ui-fonts": "static-1.337",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3594",
      "usage-tracker-anonymous": "static-1.5406",
      "bender-build-tools": "static-1.2756",
      "dispatcher": "static-1.129",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.759",
      "hubspotter-http": "static-1.4343",
      "mobile-manifest-mixins": "static-1.452",
      "quartz-auth": "static-1.190",
      "quartz-head": "static-1.180",
      "quartz-test": "static-1.190",
      "bend-plugin-foundations-theming": "static-1.2539",
      "foundations-theming-base": "static-1.3041",
      "stylex": "static-1.25",
      "ts-schema": "static-1.3770",
      "apollo-stack-hubspot": "static-3.79",
      "avatar-components": "static-1.2117",
      "content-assistance-lib": "static-1.7240",
      "crm-component-utils": "static-1.38102",
      "crm-display-components": "static-1.23852",
      "crm-fe-perf": "static-1.22533",
      "crm-links": "static-1.5898",
      "crm-message-bus": "static-1.41955",
      "crm-search-service-types": "static-1.815",
      "crm-source-interpretation-lib": "static-1.4987",
      "customer-data-communicator": "static-1.44501",
      "customer-data-email": "static-1.17441",
      "customer-data-filters-ui": "static-1.38364",
      "customer-data-objects-ui-components": "static-1.12652",
      "customer-data-properties": "static-1.50343",
      "customer-data-rte": "static-1.32138",
      "customer-data-ui-utilities": "static-1.9478",
      "draft-plugins": "static-2.21063",
      "file-manager-components": "static-1.22476",
      "FileManagerCore": "static-1.37975",
      "framework-data-schema-resolvers": "static-1.6520",
      "frontend-preferences-client": "static-1.7577",
      "hubspot-apollo-client": "static-1.4532",
      "hubspot-prosemirror": "static-1.17222",
      "object-comments-thread-lib": "static-1.9741",
      "reference-resolvers-lite": "static-1.7746",
      "ui-addon-upgrades": "static-9.17345",
      "universal-associations-select": "static-1.10608",
      "ai-components-ui-library": "static-1.7977",
      "final-form": "static-1.63",
      "inbound-db-properties-service-client": "static-1.3546",
      "property-translator": "static-1.5070",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.75",
      "hub-http-shared-msw-handlers": "static-1.9116",
      "hubspotter-http-shared-msw-handlers": "static-1.9114",
      "superstore": "static-1.4424",
      "ui-addon-video-player": "static-1.8377",
      "ui-coaching-tips": "static-1.27544",
      "card-properties-lib": "static-1.43125",
      "crm-actions": "static-1.5924",
      "crm-cards-data": "static-1.990",
      "crm-cards-sdk": "static-1.42475",
      "customer-data-properties-shared-msw-handlers": "static-1.8443",
      "customer-data-property-utils": "static-1.7719",
      "customer-data-tracking": "static-1.6515",
      "usage-tracker-container": "static-1.6979",
      "framework-data-table": "static-2.11080",
      "location-customization-utils-lib": "static-1.8105",
      "calling-error-reporting": "static-1.30946",
      "calling-internal-common": "static-1.30940",
      "calling-usage-tracker": "static-1.6194",
      "crm_data": "static-4.90759",
      "crm_schema": "static-3.90798",
      "crm-legacy-global-containers": "static-1.23545",
      "customer-data-content": "static-1.26591",
      "draft-content-plugins": "static-1.27405",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23401",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23211",
      "EmailSignatureEditor": "static-1.23663",
      "FileManagerLib": "static-1.38116",
      "hubspot-prosemirror-plugins": "static-1.17214",
      "integration-settings-components": "static-1.14347",
      "integrations-lib": "static-1.14955",
      "integrations-tracking-lib": "static-1.5237",
      "native-integrations-shared-strings": "static-1.7438",
      "nav-meta": "static-1.28499",
      "onboarding-scopes": "static-1.6097",
      "outreach-assistant-email-generation": "static-1.5521",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36758",
      "react-colorpicker": "static-2.9870",
      "react-dnd-compat": "static-1.4280",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7814",
      "rich-text-lib": "static-1.19224",
      "sales-email-signature-service-client": "static-1.3494",
      "sequences-lib": "static-1.7468",
      "timezone-utils": "static-2.4902",
      "ui-addon-i18n": "static-1.10778",
      "ui-addon-iframeable": "static-1.8659",
      "ui-business-units-lib": "static-1.8661",
      "ui-gdpr-components": "static-1.10002",
      "ui-shepherd-react": "static-3.9796",
      "user-context": "static-1.4742",
      "whatsapp-sending-lib": "static-1.4494",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4304",
      "salesImages": "static-1.518",
      "customer-data-filters-ui-msw-helpers": "static-1.20798",
      "customer-data-reference-ui-components": "static-1.12781",
      "FormUrlGenerator": "static-2.4387",
      "framework-builder-read-service-client": "static-1.3713",
      "framework-data-schema-quick-fetch": "static-1.6425",
      "inbound-db-meta-service-client": "static-1.3325",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.618",
      "onboarding-tours": "static-1.16057",
      "reporting-datasets-permissions-lib": "static-1.12586",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.21020",
      "calling-global-api": "static-1.63170",
      "calling-lifecycle-internal": "static-1.64552",
      "calling-lifecycle-messages": "static-1.56846",
      "commerce-products-lib": "static-1.8405",
      "conditional-properties-service-client": "static-1.3487",
      "external-options-client-types": "static-1.3848",
      "google-libphonenumber": "static-1.31",
      "inbound-db-associations-writes-service-client": "static-1.2823",
      "inbounddb-objects-service-types": "static-1.3916",
      "meetings-icalendar-utils-lib": "static-1.289",
      "multi-currency-client-types": "static-1.3388",
      "object-builder-ui-client": "static-1.47490",
      "pipeline-validation-client-types": "static-1.3651",
      "property-value-citations": "static-1.957",
      "smart-property-lib": "static-1.5350",
      "tiered-pricing": "static-1.599",
      "ui-addon-form-validation": "static-1.10653",
      "immerable": "static-1.3811",
      "video-components-external": "static-1.10128",
      "video-data-lib": "static-1.33786",
      "audio-components": "static-1.5408",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35627",
      "ui-universal-auth": "static-1.8483",
      "video-components": "static-1.12131",
      "video-embed": "static-1.34620",
      "batch-promise": "static-1.1183",
      "crm-pipelines-api-client-types": "static-1.3832",
      "persist-promise": "static-1.3340",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24317",
      "knowledge-content-types": "static-1.8256",
      "payment-link-components": "static-1.22543",
      "ui-addon-emoji-picker": "static-1.9546",
      "call-summary": "static-1.37861",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9262",
      "feature-store-service-types": "static-1.4184",
      "growth-monetization-service-types": "static-1.4191",
      "merchandise-lib": "static-1.253",
      "purchase-motions-components": "static-1.5249",
      "self-service-api": "static-1.9878",
      "upgrade-management-service-types": "static-1.4175",
      "chatspot-client-types": "static-1.10292",
      "chatspot-core": "static-1.19768",
      "ContentUtils": "static-1.67162",
      "copilot-toolkit": "static-1.10168",
      "growth-onboarding-feedback-components": "static-1.6241",
      "customer-data-sidebar": "static-2.45044",
      "enrichment-properties-lib": "static-1.14468",
      "customer-data-associations": "static-1.6992",
      "deal-intel-decorators": "static-1.804",
      "reporting-data": "static-1.65889",
      "ui-addon-draggable": "static-3.4401",
      "crm-record-cards-service-types": "static-1.3325",
      "crm_universal": "static-1.21439",
      "SalesContentIndexUI": "static-3.8675",
      "signup-ui-lego-core": "static-1.20091",
      "content-embed-lib": "static-1.6993",
      "data-model-builder-lib": "static-1.11183",
      "remote-ui": "static-1.58",
      "ui-components-test-utils": "static-1.5210",
      "ui-extensions-remote-renderer": "static-1.16044",
      "universal-page-editor-lib": "static-1.2650",
      "integrations-error-boundary-lib": "static-1.12370",
      "laboratory-lib": "static-3.6794",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10029",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.44942",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15813",
      "sequences-client-types-lib": "static-1.7325",
      "foundations-components-test-utils": "static-1.4686",
      "magpie-lib": "static-1.5227",
      "navigation-messaging": "static-1.6189",
      "getting-started-shared-tasks": "static-1.17443",
      "getting-started-shared-tasks-store": "static-1.16561",
      "onboarding-tours-utils": "static-1.123",
      "whatsapp-management-lib": "static-1.7653",
      "growth-data-modal": "static-1.4982",
      "growth-onboarding-confetti": "static-1.2707",
      "growth-onboarding-next-action-utils": "static-1.1139",
      "navigation-components": "static-1.16862",
      "onboarding-tours-client": "static-1.4271",
      "ui-shepherd-tracker": "static-1.7177",
      "shared-worker-versioning": "static-1.10672",
      "calling-orchestration-shared-library": "static-1.34356",
      "products-iframe-lib": "static-1.6972",
      "products-ui-components-shared-msw-handlers": "static-1.9498",
      "breeze-intelligence-kit": "static-1.5112",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9199",
      "fsm": "static-1.3386",
      "policy-lib": "static-1.6458",
      "react-tinymce": "static-1.54227",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53353",
      "tinymce-plugins": "static-1.56467",
      "tinymce-themes": "static-1.55323",
      "content-media-composition-data-lib": "static-1.10836",
      "content-media-compositions": "static-2.14843",
      "idb-keyval": "static-1.37",
      "magpie-types": "static-1.4687",
      "media-bridge-lib": "static-1.18339",
      "content-icons-ui": "static-1.2098",
      "social-insights-client-types": "static-1.21010",
      "outpost": "static-1.3873",
      "commerce-analytics-service-client": "static-1.3341",
      "ui-addon-opt": "static-4.8046",
      "commerce-tours-lib": "static-1.5494",
      "growth-onboarding-reliability": "static-1.4744",
      "sales-checkout-service-client": "static-1.3353",
      "ai-addon-copilot-preview": "static-1.7189",
      "calling-cross-tab-library": "static-1.18907",
      "calling-lifecycle-usage-tracker": "static-1.7783",
      "wootric-nps": "static-1.6590",
      "nav-client-types": "static-1.1987",
      "purchase-motions-api": "static-1.5252",
      "trials-service-types": "static-1.3592",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4458",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2707",
      "card-payment-highlight-lib": "static-1.36118",
      "card-subscription-highlight-lib": "static-1.38541",
      "commerce-billing-lib": "static-1.18093",
      "commerce-contract-lib": "static-1.10631",
      "crm_components": "static-3.90759",
      "invoices-highlight-card-lib": "static-1.53544",
      "orders-highlight-card-lib": "static-1.20533",
      "products-highlight-card-lib": "static-1.16689",
      "project-storage": "static-1.4389",
      "quotes-highlight-card-lib": "static-1.70671",
      "usage-based-billing-components-lib": "static-1.7643",
      "deal-intel-utils": "static-1.808",
      "reporting-client-types": "static-1.2334",
      "react-flip-move": "static-1.63",
      "FireAlarmUi": "static-1.4192",
      "sales-templates-service-types-lib": "static-1.3860",
      "ui-asset-management-lib": "static-1.10493",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9236",
      "collaboration-sidebar": "static-1.56753",
      "conditional-property-settings-modal": "static-1.11645",
      "data-model-commons-lib": "static-1.11566",
      "feedback-loader": "static-1.28608",
      "html-to-image": "static-1.47",
      "object-definition-builder-lib": "static-1.6707",
      "property-management-iframe": "static-1.11753",
      "reactflow": "static-1.57",
      "simple-data-table": "static-1.1804",
      "used-in-list-lib": "static-1.6562",
      "visual-association": "static-1.5490",
      "highcharts": "static-8.97",
      "reporting-visualizations": "static-1.57966",
      "ui-extensibility-client-types": "static-1.3610",
      "automation-platform-service-types": "static-1.2421",
      "ContentData": "static-1.67237",
      "email-portal-health-service-types": "static-1.630",
      "marketing-email-service-types": "static-1.1731",
      "reactive-lib": "static-1.381",
      "content-whatsapp-service-types": "static-1.162",
      "marketing-platform-lib": "static-1.6485",
      "short-messages-app-service-client": "static-1.3665",
      "ui-tool-access": "static-1.9789",
      "calling-orchestration-schema": "static-1.34581",
      "sales-views-client-types": "static-1.3946",
      "trellis-story-utils": "static-1.4180",
      "storybook-react": "static-1.26",
      "hub-http-contrib": "static-1.2703",
      "interframe": "static-3.4444",
      "tinymce-data": "static-1.39438",
      "ui-addon-sales-email": "static-1.4872",
      "codemirror": "static-5.88",
      "layout-dnd-components": "static-1.11781",
      "layout-dnd-utils": "static-1.10756",
      "react-codemirror": "static-1.10258",
      "ui-brand-identity-lib": "static-1.13297",
      "NamespacedHubStyle": "static-2.8768",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8843",
      "ai-settings-ui-library": "static-1.7111",
      "chirp-fetch": "static-1.1537",
      "copilot-plugins": "static-1.10141",
      "eligibility-engine-service-types": "static-1.2873",
      "commerce-shared-components-lib": "static-1.17521",
      "commerce-subscription-lib": "static-1.36118",
      "commerce-tools-ui-lib": "static-1.9456",
      "usage-tracker-session-replay": "static-1.4675",
      "utility-belt": "static-1.2197",
      "payments-enrollment-embed-lib": "static-1.21469",
      "quotes-ui-lib": "static-1.79389",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6482",
      "invoices-ui-lib": "static-1.53560",
      "commerce-products-api": "static-1.1735",
      "SafeStorage": "static-1.4054",
      "invoices-iframe-lib": "static-1.55618",
      "quotes-modal-lib": "static-1.101346",
      "reporting-ui-components": "static-2.63162",
      "subscription-experience-data-types": "static-1.14381",
      "association-translator": "static-1.2849",
      "crm-settings-header-lib": "static-1.7954",
      "settings-ui-nav": "static-2.9797",
      "chatspot-widget-iframe": "static-1.19760",
      "collaboration-sidebar-common": "static-1.1550",
      "crm-properties-common-lib": "static-1.5524",
      "ui-addon-draggable-compat": "static-2.3910",
      "property-management-common": "static-1.4040",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14592",
      "advanced-menus-lib": "static-1.11594",
      "ExportDialog": "static-6.10041",
      "ui-memberships-settings-lib": "static-1.33034",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9081",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13104",
      "highlight.js": "static-1.72",
      "reporting-action-components": "static-1.40323",
      "ui-addon-react-router-dom": "static-1.9195",
      "growth-onboarding-empty-states": "static-1.5153",
      "InboxConnectUtils": "static-4.13843",
      "payments-post-enroll-local-storage-lib": "static-1.4744",
      "qrcode-generator": "static-1.62",
      "amplitude-session-replay-browser": "static-1.53",
      "marketplace-ui-apps-core": "static-1.17094",
      "stripe-embedded-components": "static-1.6900",
      "products-ui-components": "static-1.38924",
      "totals-ui-components": "static-1.22618",
      "reporting-plugins": "static-1.9776",
      "reporting-reports": "static-1.65568",
      "reporting-snowflake": "static-1.54508",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14591",
      "simple-menus-lib": "static-1.16108",
      "academy-common-lib": "static-1.12564",
      "dashboard-lib": "static-1.80065",
      "share-with-third-party-component-lib": "static-1.8343",
      "developer-experience-shared-components": "static-1.10077",
      "marketplace-ui-client-types": "static-1.15967",
      "marketplace-ui-common": "static-1.18560",
      "ui-addon-integrations-directory-panel": "static-2.7633",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.402",
      "property-description-translator": "static-1.3516",
      "commerce-totals-service-types": "static-1.3507",
      "campaign-roi-lib": "static-1.7863",
      "academy-service-client": "static-1.3306",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3528",
      "oauth-service-types": "static-1.3895",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27897",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4356",
      "atom": "/atom/static-1.4729",
      "conversations-async-data": "/conversations-async-data/static-2.7317",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8533",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15620",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12281",
      "conversations-message-history": "/conversations-message-history/static-1.11599",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10152",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21260",
      "head-dlb": "/head-dlb/static-1.4702",
      "hs-promise-utils": "/hs-promise-utils/static-1.5244",
      "hs-test-utils": "/hs-test-utils/static-1.7639",
      "hubspot-dlb": "/hubspot-dlb/static-2.1767",
      "HubStyleTokens": "/HubStyleTokens/static-2.11072",
      "I18n": "/I18n/static-7.1528",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2666",
      "jasmine-runner": "/jasmine-runner/static-1.6108",
      "quartz": "/quartz/static-1.6515",
      "react-dlb": "/react-dlb/static-1.67",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.58",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4130",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4181",
      "usage-tracker": "/usage-tracker/static-1.6989",
      "usage-tracker-core": "/usage-tracker-core/static-1.6839",
      "usage-tracker-public": "/usage-tracker-public/static-1.6800",
      "viral-links-lib": "/viral-links-lib/static-1.6670",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5781",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4433",
      "conversations-prop-types": "/conversations-prop-types/static-1.7102",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19997",
      "cssUtils": "/cssUtils/static-1.683",
      "enviro": "/enviro/static-4.371",
      "flux-actions": "/flux-actions/static-1.294",
      "foundations-components": "/foundations-components/static-1.7203",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5820",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3819",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9286",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.334",
      "raven": "/raven/static-3.5564",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.58",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.65",
      "react-rhumb": "/react-rhumb/static-1.16279",
      "react-utils": "/react-utils/static-2.5045",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7796",
      "signup-constants": "/signup-constants/static-1.18081",
      "styled-components": "/styled-components/static-2.83",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5403",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5592",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
      "raven-hubspot": "/raven-hubspot/static-1.5871",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3093",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.293",
      "quartz-core": "/quartz-core/static-1.5734",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4484",
      "foundations-theming": "/foundations-theming/static-1.4056",
      "UIComponents": "/UIComponents/static-3.8019",
      "cv-backend-services": "/cv-backend-services/static-1.1429",
      "immutable-less": "/immutable-less/static-1.4305",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6907",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31961",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2068",
      "customer-data-objects": "/customer-data-objects/static-1.7264",
      "data-fetching-client": "/data-fetching-client/static-1.9329",
      "icons": "/icons/static-2.601",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4258",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "ui-images": "/ui-images/static-2.1042",
      "HeadJS": "/HeadJS/static-2.679",
      "framer-motion": "/framer-motion/static-1.62",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2750",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.144",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jasmine": "/jasmine/static-4.3987",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
      "HubStyle": "/HubStyle/static-2.11380",
      "quartz-i18n": "/quartz-i18n/static-1.190",
      "sassPrefix": "/sassPrefix/static-1.149",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3472",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1772",
      "hs-story-utils": "/hs-story-utils/static-1.9085",
      "react-virtualized": "/react-virtualized/static-2.91",
      "tanstack-table": "/tanstack-table/static-1.48",
      "trellis-assets": "/trellis-assets/static-1.899",
      "ui-fonts": "/ui-fonts/static-1.337",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3594",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5406",
      "bender-build-tools": "/bender-build-tools/static-1.2756",
      "dispatcher": "/dispatcher/static-1.129",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.759",
      "hubspotter-http": "/hubspotter-http/static-1.4343",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.452",
      "quartz-auth": "/quartz-auth/static-1.190",
      "quartz-head": "/quartz-head/static-1.180",
      "quartz-test": "/quartz-test/static-1.190",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2539",
      "foundations-theming-base": "/foundations-theming-base/static-1.3041",
      "stylex": "/stylex/static-1.25",
      "ts-schema": "/ts-schema/static-1.3770",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
      "avatar-components": "/avatar-components/static-1.2117",
      "content-assistance-lib": "/content-assistance-lib/static-1.7240",
      "crm-component-utils": "/crm-component-utils/static-1.38102",
      "crm-display-components": "/crm-display-components/static-1.23852",
      "crm-fe-perf": "/crm-fe-perf/static-1.22533",
      "crm-links": "/crm-links/static-1.5898",
      "crm-message-bus": "/crm-message-bus/static-1.41955",
      "crm-search-service-types": "/crm-search-service-types/static-1.815",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4987",
      "customer-data-communicator": "/customer-data-communicator/static-1.44501",
      "customer-data-email": "/customer-data-email/static-1.17441",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38364",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12652",
      "customer-data-properties": "/customer-data-properties/static-1.50343",
      "customer-data-rte": "/customer-data-rte/static-1.32138",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9478",
      "draft-plugins": "/draft-plugins/static-2.21063",
      "file-manager-components": "/file-manager-components/static-1.22476",
      "FileManagerCore": "/FileManagerCore/static-1.37975",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6520",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7577",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4532",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17222",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9741",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7746",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17345",
      "universal-associations-select": "/universal-associations-select/static-1.10608",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7977",
      "final-form": "/final-form/static-1.63",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3546",
      "property-translator": "/property-translator/static-1.5070",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.75",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9116",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9114",
      "superstore": "/superstore/static-1.4424",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8377",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27544",
      "card-properties-lib": "/card-properties-lib/static-1.43125",
      "crm-actions": "/crm-actions/static-1.5924",
      "crm-cards-data": "/crm-cards-data/static-1.990",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42475",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8443",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7719",
      "customer-data-tracking": "/customer-data-tracking/static-1.6515",
      "usage-tracker-container": "/usage-tracker-container/static-1.6979",
      "framework-data-table": "/framework-data-table/static-2.11080",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8105",
      "calling-error-reporting": "/calling-error-reporting/static-1.30946",
      "calling-internal-common": "/calling-internal-common/static-1.30940",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6194",
      "crm_data": "/crm_data/static-4.90759",
      "crm_schema": "/crm_schema/static-3.90798",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23545",
      "customer-data-content": "/customer-data-content/static-1.26591",
      "draft-content-plugins": "/draft-content-plugins/static-1.27405",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23401",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23211",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23663",
      "FileManagerLib": "/FileManagerLib/static-1.38116",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17214",
      "integration-settings-components": "/integration-settings-components/static-1.14347",
      "integrations-lib": "/integrations-lib/static-1.14955",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5237",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7438",
      "nav-meta": "/nav-meta/static-1.28499",
      "onboarding-scopes": "/onboarding-scopes/static-1.6097",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5521",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36758",
      "react-colorpicker": "/react-colorpicker/static-2.9870",
      "react-dnd-compat": "/react-dnd-compat/static-1.4280",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7814",
      "rich-text-lib": "/rich-text-lib/static-1.19224",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3494",
      "sequences-lib": "/sequences-lib/static-1.7468",
      "timezone-utils": "/timezone-utils/static-2.4902",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10778",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8659",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8661",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10002",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9796",
      "user-context": "/user-context/static-1.4742",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4494",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4304",
      "salesImages": "/salesImages/static-1.518",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20798",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12781",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4387",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3713",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6425",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3325",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.618",
      "onboarding-tours": "/onboarding-tours/static-1.16057",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12586",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.21020",
      "calling-global-api": "/calling-global-api/static-1.63170",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64552",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56846",
      "commerce-products-lib": "/commerce-products-lib/static-1.8405",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3487",
      "external-options-client-types": "/external-options-client-types/static-1.3848",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2823",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3916",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.289",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3388",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47490",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3651",
      "property-value-citations": "/property-value-citations/static-1.957",
      "smart-property-lib": "/smart-property-lib/static-1.5350",
      "tiered-pricing": "/tiered-pricing/static-1.599",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10653",
      "immerable": "/immerable/static-1.3811",
      "video-components-external": "/video-components-external/static-1.10128",
      "video-data-lib": "/video-data-lib/static-1.33786",
      "audio-components": "/audio-components/static-1.5408",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35627",
      "ui-universal-auth": "/ui-universal-auth/static-1.8483",
      "video-components": "/video-components/static-1.12131",
      "video-embed": "/video-embed/static-1.34620",
      "batch-promise": "/batch-promise/static-1.1183",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3832",
      "persist-promise": "/persist-promise/static-1.3340",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24317",
      "knowledge-content-types": "/knowledge-content-types/static-1.8256",
      "payment-link-components": "/payment-link-components/static-1.22543",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9546",
      "call-summary": "/call-summary/static-1.37861",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9262",
      "feature-store-service-types": "/feature-store-service-types/static-1.4184",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4191",
      "merchandise-lib": "/merchandise-lib/static-1.253",
      "purchase-motions-components": "/purchase-motions-components/static-1.5249",
      "self-service-api": "/self-service-api/static-1.9878",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4175",
      "chatspot-client-types": "/chatspot-client-types/static-1.10292",
      "chatspot-core": "/chatspot-core/static-1.19768",
      "ContentUtils": "/ContentUtils/static-1.67162",
      "copilot-toolkit": "/copilot-toolkit/static-1.10168",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6241",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45044",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14468",
      "customer-data-associations": "/customer-data-associations/static-1.6992",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.804",
      "reporting-data": "/reporting-data/static-1.65889",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4401",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3325",
      "crm_universal": "/crm_universal/static-1.21439",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8675",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20091",
      "content-embed-lib": "/content-embed-lib/static-1.6993",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11183",
      "remote-ui": "/remote-ui/static-1.58",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5210",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16044",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2650",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12370",
      "laboratory-lib": "/laboratory-lib/static-3.6794",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10029",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.44942",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15813",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7325",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4686",
      "magpie-lib": "/magpie-lib/static-1.5227",
      "navigation-messaging": "/navigation-messaging/static-1.6189",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17443",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16561",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.123",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7653",
      "growth-data-modal": "/growth-data-modal/static-1.4982",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2707",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1139",
      "navigation-components": "/navigation-components/static-1.16862",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4271",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7177",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10672",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34356",
      "products-iframe-lib": "/products-iframe-lib/static-1.6972",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9498",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5112",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9199",
      "fsm": "/fsm/static-1.3386",
      "policy-lib": "/policy-lib/static-1.6458",
      "react-tinymce": "/react-tinymce/static-1.54227",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53353",
      "tinymce-plugins": "/tinymce-plugins/static-1.56467",
      "tinymce-themes": "/tinymce-themes/static-1.55323",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10836",
      "content-media-compositions": "/content-media-compositions/static-2.14843",
      "idb-keyval": "/idb-keyval/static-1.37",
      "magpie-types": "/magpie-types/static-1.4687",
      "media-bridge-lib": "/media-bridge-lib/static-1.18339",
      "content-icons-ui": "/content-icons-ui/static-1.2098",
      "social-insights-client-types": "/social-insights-client-types/static-1.21010",
      "outpost": "/outpost/static-1.3873",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3341",
      "ui-addon-opt": "/ui-addon-opt/static-4.8046",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5494",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4744",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3353",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7189",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18907",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7783",
      "wootric-nps": "/wootric-nps/static-1.6590",
      "nav-client-types": "/nav-client-types/static-1.1987",
      "purchase-motions-api": "/purchase-motions-api/static-1.5252",
      "trials-service-types": "/trials-service-types/static-1.3592",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4458",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2707",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36118",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38541",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18093",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10631",
      "crm_components": "/crm_components/static-3.90759",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53544",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20533",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16689",
      "project-storage": "/project-storage/static-1.4389",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70671",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7643",
      "deal-intel-utils": "/deal-intel-utils/static-1.808",
      "reporting-client-types": "/reporting-client-types/static-1.2334",
      "react-flip-move": "/react-flip-move/static-1.63",
      "FireAlarmUi": "/FireAlarmUi/static-1.4192",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3860",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10493",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9236",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56753",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11645",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11566",
      "feedback-loader": "/feedback-loader/static-1.28608",
      "html-to-image": "/html-to-image/static-1.47",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6707",
      "property-management-iframe": "/property-management-iframe/static-1.11753",
      "reactflow": "/reactflow/static-1.57",
      "simple-data-table": "/simple-data-table/static-1.1804",
      "used-in-list-lib": "/used-in-list-lib/static-1.6562",
      "visual-association": "/visual-association/static-1.5490",
      "highcharts": "/highcharts/static-8.97",
      "reporting-visualizations": "/reporting-visualizations/static-1.57966",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3610",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2421",
      "ContentData": "/ContentData/static-1.67237",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.630",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1731",
      "reactive-lib": "/reactive-lib/static-1.381",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.162",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6485",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3665",
      "ui-tool-access": "/ui-tool-access/static-1.9789",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34581",
      "sales-views-client-types": "/sales-views-client-types/static-1.3946",
      "trellis-story-utils": "/trellis-story-utils/static-1.4180",
      "storybook-react": "/storybook-react/static-1.26",
      "hub-http-contrib": "/hub-http-contrib/static-1.2703",
      "interframe": "/interframe/static-3.4444",
      "tinymce-data": "/tinymce-data/static-1.39438",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4872",
      "codemirror": "/codemirror/static-5.88",
      "layout-dnd-components": "/layout-dnd-components/static-1.11781",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10756",
      "react-codemirror": "/react-codemirror/static-1.10258",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13297",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8768",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8843",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7111",
      "chirp-fetch": "/chirp-fetch/static-1.1537",
      "copilot-plugins": "/copilot-plugins/static-1.10141",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2873",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17521",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36118",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9456",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4675",
      "utility-belt": "/utility-belt/static-1.2197",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21469",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79389",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6482",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53560",
      "commerce-products-api": "/commerce-products-api/static-1.1735",
      "SafeStorage": "/SafeStorage/static-1.4054",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55618",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101346",
      "reporting-ui-components": "/reporting-ui-components/static-2.63162",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14381",
      "association-translator": "/association-translator/static-1.2849",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7954",
      "settings-ui-nav": "/settings-ui-nav/static-2.9797",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19760",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1550",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5524",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3910",
      "property-management-common": "/property-management-common/static-1.4040",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14592",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11594",
      "ExportDialog": "/ExportDialog/static-6.10041",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33034",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9081",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13104",
      "highlight.js": "/highlight.js/static-1.72",
      "reporting-action-components": "/reporting-action-components/static-1.40323",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9195",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5153",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13843",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4744",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17094",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6900",
      "products-ui-components": "/products-ui-components/static-1.38924",
      "totals-ui-components": "/totals-ui-components/static-1.22618",
      "reporting-plugins": "/reporting-plugins/static-1.9776",
      "reporting-reports": "/reporting-reports/static-1.65568",
      "reporting-snowflake": "/reporting-snowflake/static-1.54508",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14591",
      "simple-menus-lib": "/simple-menus-lib/static-1.16108",
      "academy-common-lib": "/academy-common-lib/static-1.12564",
      "dashboard-lib": "/dashboard-lib/static-1.80065",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8343",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10077",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15967",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18560",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7633",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.402",
      "property-description-translator": "/property-description-translator/static-1.3516",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3507",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7863",
      "academy-service-client": "/academy-service-client/static-1.3306",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3528",
      "oauth-service-types": "/oauth-service-types/static-1.3895",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};